var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-changed-field-list"},[_c('h4',{staticClass:"notifications-changed-field-list__title"},[_vm._v("ИЗМЕНЕНИЯ")]),_vm._l((_vm.list),function(ref,index){
var type = ref[0];
var value = ref[1];
return _c('notifications-changed-field',{key:index,staticClass:"notifications-changed-field-list__item",attrs:{"object-type":_vm.objectType,"type":type,"value":value}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }